import React, { useCallback, useEffect, useState } from "react";
import axios from "axios";
import Config from "../../config";

type Status = "checking" | "ok" | "fail";
type PingResponse = {
  Message: string;
  uuid: string;
};

export function ConnectionStatus() {
  const [status, setStatus] = useState<Status>("checking");
  const [detail, setDetail] = useState<string>("");

  const check = useCallback(async () => {
    setStatus("checking");
    setDetail("");
    try {
      const response = await axios.get<PingResponse>(
        `${Config.BE_BASE_URL}/ping`,
        {
          headers: {
            "Content-Type": "application/json"
          }
        }
      );
      setStatus("ok");
      setDetail(`request_id: ${response.data.uuid}`);
    } catch (error) {
      setStatus("fail");
      setDetail(error instanceof Error ? error.message : String(error));
    }
  }, []);

  useEffect(() => {
    check();
  }, [check]);

  return <pre>{`${status.toUpperCase()}${detail ? `\n${detail}` : ""}`}</pre>;
}

export default ConnectionStatus;
